import React from "react";

import { usePhotoPreprocessProgress } from "../../hooks/use-photo-preprocess-progress";
import { useLabels } from "../../hooks/useLabels";
import { PhotoPreprocessProgress } from "./photo-preprocess-progress";

import { labels } from "./labels";

export const PhotoPreprocessProgressContainer = () => {
	const [progress] = usePhotoPreprocessProgress();

	const [[message]] = useLabels([labels.message]);
	return progress ? (
		<PhotoPreprocessProgress
			message={eXpress.utils.formatString(
				message,
				(progress.progressCount || 0).toString(),
				progress.total.toString(),
			)}
		/>
	) : null;
};
PhotoPreprocessProgressContainer.displayName = "PhotoPreprocessProgressContainer";
